import styled from '@emotion/styled';

export const Container = styled.textarea`
	height: 20rem;
	padding: 1.2rem;
	padding-bottom: 0rem;
	resize: none;
	color: #212529;
	border-color: #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	overflow: auto; /* 스크롤은 되게 */
	scrollbar-width: none; /* Firefox용 */
	-ms-overflow-style: none; /* IE, Edge 구버전용 */
	&:focus {
		outline: none;
		border-color: #00377b;
	}

	&::-webkit-scrollbar {
		display: none; /* Chrome, Safari, Edge(신버전)용 */
	}
`;
